import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './reports.css'
function ReportsKba() {
    const navigate = useNavigate();
    const pieFullChartRef = useRef(null);
    const pieChartRef = useRef(null);
    const barChartRef = useRef(null);
    const lineChartRef = useRef(null);

    useEffect(() => {
        if (pieFullChartRef.current) {
        const pieFullChart = echarts.init(pieFullChartRef.current);

        pieFullChart.setOption({
            title: {
                text: 'Knowledge Base Report',
                // subtext: 'Fake Data',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                // orient: 'vertical',
                left: 'center'
            },
            series: [
                {
                name: 'KBA',
                type: 'pie',
                radius: '50%',
                data: [
                    { value: 40, name: 'Knowledge Base', itemStyle: { color: '#C32A7C' } },
                    { value: 38, name: 'Category', itemStyle: { color: '#1A5298' } },
                    { value: 28, name: 'Sub Category', itemStyle: { color: '#124B6A' } },
                ],
                emphasis: {
                    itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
                }
            ]
        });

        // Clean up
        return () => {
            pieFullChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (pieChartRef.current) {
        const pieChart = echarts.init(pieChartRef.current);

        const pieOption = {
            legend: {
            top: 'bottom'
            },
            title: {
                text: 'Articla Stages',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            toolbox: {
            show: true,
            feature: {
                mark: { show: true },
                saveAsImage: { show: true }
            }
            },
            series: [
            {
                name: 'Article Stage',
                type: 'pie',
                radius: [50, 100],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                borderRadius: 5
                },
                data: [
                { value: 40, name: 'Total Article', itemStyle: { color: '#C32A7C' } },
                { value: 38, name: 'Draft', itemStyle: { color: '#1A5298' } },
                { value: 32, name: 'Under Approval', itemStyle: { color: '#95DAFF' } },
                { value: 30, name: 'Published', itemStyle: { color: '#CAECFF' } },
                { value: 28, name: 'Retired', itemStyle: { color: '#124B6A' } },
                ]
            }
            ]
        };

        pieChart.setOption(pieOption);

        // Clean up
        return () => {
            pieChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (barChartRef.current) {
        const barChart = echarts.init(barChartRef.current);

        const barChartOption = {
            title: {
                text: 'Published vs Retired',
                // subtext: 'Fake Data'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['Published', 'Retired'],
                // orient: 'vertical',
                left: 'left'                
            },
            toolbox: {
                show: true,
                top: 'bottom',
                feature: {
                magicType: { show: true, type: ['line', 'bar'] },
                restore: { show: true },
                saveAsImage: { show: true }
                }
            },
            calculable: true,
            xAxis: [
                {
                type: 'category',
                // prettier-ignore
                data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                }
            ],
            yAxis: [
                {
                type: 'value'
                }
            ],
            series: [
                {
                name: 'Published',
                type: 'bar',
                itemStyle: { color: '#C32A7C' },
                data: [
                    2, 4, 7, 23, 25, 76, 135, 162, 32, 20, 6, 3
                ],
                // markPoint: {
                //     data: [
                //     { type: 'max', name: 'Max' },
                //     { type: 'min', name: 'Min' }
                //     ]
                // },
                // markLine: {
                //     data: [{ type: 'average', name: 'Avg' }]
                // }
                },
                {
                name: 'Retired',
                type: 'bar',
                itemStyle: { color: '#1A5298' },
                data: [
                    2, 5, 9, 26, 28, 70, 175, 182, 48, 18, 6, 2
                ],
                // markPoint: {
                //     data: [
                //     { name: 'Max', value: 182, xAxis: 7, yAxis: 183 },
                //     { name: 'Min', value: 2, xAxis: 11, yAxis: 3 }
                //     ]
                // },
                // markLine: {
                //     data: [{ type: 'average', name: 'Avg' }]
                // }
                }
            ]
        };

        barChart.setOption(barChartOption);

        // Clean up
        return () => {
            barChart.dispose();
        };
        }
    }, []);

    useEffect(() => {
        if (lineChartRef.current) {
        const lineChart = echarts.init(lineChartRef.current);

        const lineChartOption = {
            title: {
                text: 'Usage of Articles ',
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: 'bottom',
                left: 'center'
            },
            series: [
                {
                name: 'Usage',
                type: 'pie',
                radius: ['40%', '70%'],
                center: ['50%', '70%'],
                // adjust the start and end angle
                startAngle: 180,
                endAngle: 360,
                data: [
                    { value: 1048, name: 'Likes', itemStyle: { color: '#C32A7C' } },
                    { value: 580, name: 'Helpful', itemStyle: { color: '#CAECFF' } },
                    { value: 300, name: 'Total view', itemStyle: { color: '#95DAFF' } },
                    { value: 484, name: 'Unhelpful', itemStyle: { color: '#1A5298' } },
                    { value: 735, name: 'Dis likes', itemStyle: { color: '#124B6A' } }
                ]
                }
            ]
        };

        lineChart.setOption(lineChartOption);

        // Clean up
        return () => {
            lineChart.dispose();
        };
        }
    }, []);

    // useEffect(() => {
    //     if (lineChartRef.current) {
    //     const lineChart = echarts.init(lineChartRef.current);

    //     const lineChartOption = {
    //         title: {
    //             text: 'Barchart for Jobseekers',
    //             left: 'center'
    //         },
    //         tooltip: {
    //             trigger: 'item'
    //         },
    //         xAxis: {
    //             type: 'category',
    //             data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    //         },
    //         yAxis: {
    //             type: 'value'
    //         },
    //         series: [
    //             {
    //             data: [
    //                 { value: 190, itemStyle: { color: '#C32A7C' } },
    //                 { value: 100, itemStyle: { color: '#1A5298' } },
    //                 { value: 50, itemStyle: { color: '#95DAFF' } },
    //                 { value: 170, itemStyle: { color: '#CAECFF' } },
    //                 { value: 120, itemStyle: { color: '#124B6A' } },
    //             ],
    //             type: 'bar'
    //             }
    //         ]
    //     };

    //     lineChart.setOption(lineChartOption);

    //     // Clean up
    //     return () => {
    //         lineChart.dispose();
    //     };
    //     }
    // }, []);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Reports</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/reports")}>Reports</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Knowledge Article Reports</span>
                </Grid>
                <Grid size={{xs:12}} container className="my-3">
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieChartRef} style={{ width: '100%', height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={pieFullChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={barChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                    <Grid size={{md:6, xs:12}} container className="px-2 mt-3">
                        <Grid size={{xs:12}} container className="report_pagecharts">
                            <div ref={lineChartRef} style={{ width: '100%' ,height: '400px' }} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ReportsKba
